import { z } from 'zod';
import { registry } from '../registry';
import { bladderBowelCardTitles } from './gastrointestinal';
export const baseGuDetailsSection = z
    .object({
    wnl: z.boolean().optional().register(registry, { label: 'WNL' }),
    details: z
        .array(z.string())
        .optional()
        .register(registry, {
        label: 'UTI Symptoms',
        options: [
            { value: 'none', label: 'None' },
            { value: 'frequency', label: 'Frequency' },
            { value: 'urgency', label: 'Urgency' },
            { value: 'hematuria', label: 'Hematuria' },
            { value: 'foulOdor', label: 'Foul odor' },
            { value: 'cloudyUrine', label: 'Cloudy urine' },
            { value: 'fever', label: 'Fever' },
            { value: 'flankPain', label: 'Flank pain' },
            { value: 'confusionNew', label: 'Confusion (new)' },
        ],
    }),
    catheter: z
        .string()
        .optional()
        .register(registry, {
        label: 'Catheter',
        options: [
            { value: 'external', label: 'External' },
            { value: 'indwelling', label: 'Indwelling' },
            { value: 'intermittent', label: 'Intermittent' },
            { value: 'suprapubic', label: 'Suprapubic' },
        ],
    }),
    frSize: z
        .string()
        .optional()
        .register(registry, {
        label: 'FR Size',
        options: [
            { value: '14', label: '14' },
            { value: '16', label: '16' },
            { value: '18', label: '18' },
            { value: '20', label: '20' },
        ],
    }),
    balloonSize: z
        .string()
        .optional()
        .register(registry, {
        label: 'Balloon Size',
        options: [
            { value: '5ml', label: '5ml' },
            { value: '10ml', label: '10ml' },
            { value: '30ml', label: '30ml' },
        ],
    }),
    inserted: z
        .string()
        .optional()
        .register(registry, {
        label: 'Inserted/Changed',
        options: [
            { value: 'inserted', label: 'Inserted' },
            { value: 'changed', label: 'Changed' },
        ],
    }),
    date: z.string().optional().register(registry, { label: 'Date' }),
    urineColor: z
        .string()
        .optional()
        .register(registry, {
        label: 'Urine Color',
        options: [
            { value: 'amber', label: 'Amber' },
            { value: 'brown/gray', label: 'Brown/Gray' },
            { value: 'cloudy', label: 'Cloudy' },
            { value: 'concentrated/dark', label: 'Concentrated/dark' },
            { value: 'green', label: 'Green' },
            { value: 'hematuria', label: 'Hematuria' },
            { value: 'straw', label: 'Straw' },
            { value: 'yellow', label: 'Yellow' },
            { value: 'yellow/clear', label: 'Yellow/Clear' },
            { value: 'yellow/straw', label: 'Yellow/Straw' },
        ],
    }),
    urinaryFrequency: z
        .string()
        .optional()
        .register(registry, {
        label: 'Urinary Frequency',
        options: [
            { value: 'normal', label: 'Normal (4–8×/day)' },
            { value: 'frequent', label: 'Frequent (>8×/day)' },
            { value: 'infrequent', label: 'Infrequent (<3×/day)' },
            { value: 'unableToAssess', label: 'Unable to assess' },
        ],
    }),
})
    .register(registry, { label: bladderBowelCardTitles.genitourinary });
export const baseGuDetailsSectionRefined = baseGuDetailsSection.refine((data) => data.wnl ||
    data.details?.length ||
    data.catheter?.trim() ||
    data.frSize?.trim() ||
    data.balloonSize?.trim() ||
    data.inserted?.trim() ||
    data.date?.trim() ||
    data.urineColor?.trim() ||
    data.urinaryFrequency?.trim(), { message: 'At least one answer is required', path: [] });
export const baseGuClinicalNarrativeSection = z
    .object({
    wnl: z.boolean().optional().register(registry, { label: 'WNL' }),
    narrative: z.string().optional().register(registry, { label: 'Narrative' }),
})
    .register(registry, { label: bladderBowelCardTitles.guClinicalNarrative });
export const baseClinicalNarrativeSectionRefined = baseGuClinicalNarrativeSection.refine((data) => data.wnl || data.narrative?.trim(), {
    message: 'At least one answer is required',
    path: [],
});
export const baseGenitourinarySchema = z.object({
    guDetails: baseGuDetailsSection.optional(),
    clinicalNarrative: baseGuClinicalNarrativeSection.optional(),
});
export const baseGenitourinarySchemaRefined = z.object({
    guDetails: baseGuDetailsSectionRefined,
    clinicalNarrative: baseClinicalNarrativeSectionRefined,
});
